<template>
  <div>
    <div>
      <div class="titlePdf text-center html2pdf__page-break">
        <p class="font-size-36 text-dark font-weight-semibold" style="font-size: 36px;">判定結果</p>
        <div style="text-align: left;font-size: 18px;color: black;margin-top: 400px;margin-left: -125px;">
          <p>
            名前 :
            {{ infoPDF && infoPDF.information ? infoPDF.information.fullname : "" }}
          </p>
          <p>ID : {{ infoPDF.patient_id }}</p>

          <p>
            性別 :
            {{
            infoPDF.information && infoPDF.information.sex === 0
            ? "女性"
            : infoPDF.information && infoPDF.information.sex === 1
            ? "男性"
            : "無回答"
            }}
          </p>
          <p>質問 ：股関節スコア</p>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-9" style="padding-left: 0; margin-left: -30px">
        <table>
          <tbody>
            <tr
              v-for="(data, index) in hipScoreCurrent"
              :key="index"
              class="html2pdf__page-break"
              style="cursor: pointer"
            >
              <td>
                <p class="text-list-time mb-0" style="font-size: 14px; margin-bottom: 3px; margin-top: 28px">
                  {{ data.created_at | fomatDate2 }}
                </p>

                <h5 class="mb-3">
                  <span style="font-size: 13px">
                    {{ data.sub_histories | filterCurrentScore }} /
                    {{ data.sub_histories | filterMaxScore }}
                    {{ $t("menuitems.hospital.points") }}
                  </span>
                </h5>
                <div class="col-md-12">
                  <h4>{{ $t("menuitems.hospital.barChart") }}</h4>
                  <div>
                    <div v-for="(item, indexBarx) in getDataChart(index)" :key="indexBarx" class="mb-4">
                      <h4 class="card-title">{{ bars[indexBarx].name }}</h4>
                      <div class="d-flex">
                        <b-progress
                                :value="getRatio(item)"
                                :variant="bars[indexBarx].background"
                                style="border-radius: 10px"
                                :max="10"
                                height="20px"
                                class="col-md-10 test"
                        />
                        <span
                                class="col-md-2 mx-2"
                                :class="{ 'color-red': getRatio(item) < 5 }"
                        >{{ getRatio(item) }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h5>{{ $t("menuitems.hospital.radarChart") }}</h5>
                    <div>
                      <RadarChart
                        :size="`${380 * (screenWidth / 1920)}`"
                        :rectWidth="`${30 * (screenWidth / 1920)}`"
                        :rectHeight="`${20 * (screenWidth / 1920)}`"
                        :data="getDataChart(index)"
                      />
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import RadarChart from "@/components/radar/index.vue";
import { filter } from "../../helpers/Vue-Filter";
export default {
  components: {
    RadarChart,
  },

  filters: {
    ...filter,
  },

  props: ["hipscore", "infoPDF"],

  data() {
    return {
      bars: [
        { id: 1, background: "primary", name: "痛み" },
        { id: 2, background: "success", name: "歩行能力" },
        { id: 3, background: "warning", name: "日常生活動能力" },
        { id: 4, background: "secondary", name: "転倒危険性" },
        { id: 5, background: "pink", name: "可動域" },
      ],
      hipScoreCurrent: [],
      screenWidth: 1920,
      widthDesktop: 1024,

      customBar: []
    };
  },

  watch: {
    hipscore: {
      handler(value) {
        try {
          this.loading = true;
          if (this.hipscore && this.hipscore.length) {
            this.hipScoreCurrent = JSON.parse(JSON.stringify(value));
            this.hipScoreCurrent.forEach((raw) => {
              raw.sub_histories.forEach((e, index) => {
                if (!e.bars) {
                  e.bars = [];
                }
                e.bars.push(
                    Object.assign(this.bars[index], {
                      value: ((e.current_score / e.max_score) * 10).toFixed(1),
                    })
                );
              });
            });
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log(error);
        } finally {
          this.loading = false;
        }
      },
      deep: true,
    },
  },

  created() {
    window.addEventListener("resize", this.myEventHandler);
    if (!this.hipscore || this.hipscore.length == 0) {
      return;
    } else {
      this.hipScoreCurrent = JSON.parse(JSON.stringify(this.hipscore));
      this.hipScoreCurrent.forEach((raw) => {
        raw.sub_histories.forEach((e, index) => {
          if (!e.bars) {
            e.bars = [];
          }
          e.bars.push(
            Object.assign(this.bars[index], {
              value: ((e.current_score / e.max_score) * 10).toFixed(1),
            })
          );
        });
      });
    }
  },

  methods: {
    bulderChart(data, index) {
      this.hipscore[index].sub_histories.forEach((e, index) => {
        this.bars[index].value = ((e.current_score / e.max_score) * 10).toFixed(
          1
        );
      });
    },

    myEventHandler() {
      // eslint-disable-next-line no-console
      this.screenWidth =
        window.innerWidth < this.widthDesktop
          ? this.widthDesktop
          : window.innerWidth;
    },

    getDataChart(index) {
      if (!index && index < 0) return [];
      if (this.hipScoreCurrent && this.hipScoreCurrent.length > 0) {
        return this.hipScoreCurrent[index].sub_histories.map((x) => ({
          current_score: x.current_score,
          max_score: x.max_score,
        }));
      }
    },

    getRatio(item) {
      return ((item.current_score/item.max_score)*10).toFixed(1);
    }
  },

  computed: {},
};
</script>

<style scoped>
* {
  font-family: "Noto Sans JP";
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-list-locomo-7 {
  color: #1d1d1d;
  font-size: 16px;
  font-weight: 700;
}

.text-list-time {
  color: #404040;
  font-weight: 400;
  font-size: 14px;
}

.text-table {
  color: #404040;
}

.text-link {
  color: #336aff;
}

.titlePdf {
  margin: auto;
  width: 50%;
  padding: 10px;
  height: 100px !important;
  margin-top: 50%;
}

.color-red {
  color: red;
}

.bg-active-locomo {
  background: #f8f9fa;
}

.text-end {
  align-items: end;
}

.undefine {
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #404040;
}

::v-deep .test .bg-primary {
  background: #9571fc !important;
}
::v-deep .test .bg-success {
  background: #32bab1 !important;
}
::v-deep .test .bg-warning {
  background: #f7a659 !important;
}
::v-deep .test .bg-secondary {
  background: #7d9994 !important;
}
::v-deep .test .bg-pink {
  background: #fb84b1 !important;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.scroll {
  max-height: 50vh;
  overflow-y: scroll;
}
.font-size-36 {
  font-size: 36px;
}
</style>
